import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-settings-skeleton',
  templateUrl: './shop-settings-skeleton.component.html',
  styleUrls: ['./shop-settings-skeleton.component.scss']
})
export class ShopSettingsSkeletonComponent {}
